import { useStaff } from "@gymflow/api";
import { useContext, useEffect } from "react";

import { useClubSettings } from "../providers";
import { AuthenticationContext } from "../providers/authentication/AuthenticationContext";
import useGymflowModels from "../store";

declare global {
  interface Window {
    Featurebase: any;
  }
}
export function useFeaturebase() {
  const { api } = useGymflowModels();
  const { userId: loggedInId } = useContext(AuthenticationContext);
  const { data: staff } = useStaff({ api, staffId: loggedInId });
  const {
    propertiesSettings: { club, webSettings },
  } = useClubSettings();

  useEffect(() => {
    if (!staff?.email || !club || !webSettings) {
      window.Featurebase("shutdown");
      return;
    }
    window.Featurebase("identify", {
      organization: "gymflow",
      email: staff.email,
      id: loggedInId,
      name: `${staff.firstName} ${staff.lastName}`,
      createdAt: staff.createdDate,
      theme: "light",
      language: "en",
      profilePicture: staff.picture ?? "",
      customFields: {
        role: staff.role,
        phone: staff.mobileNumber,
        kisiEnabled: club.kisiStatus !== "DISABLED" ? "ENABLED" : "DISABLED",
        homeClub: club.name,
        timezone: club.timezone,
        smsEnabled: club.smsEnabled ? "ENABLED" : "DISABLED",
        clubId: club.id.toString(),
        clubCode: club.codeName,
        websiteHomePageUrl: webSettings.yourWebsiteUrl,
      },
    });
    window.Featurebase("boot", {
      appId: "64c6a83e85ab4ae417fb2806",
      email: staff?.email,
      userId: loggedInId,
      userHash: loggedInId,
      createdAt: new Date().toISOString(),
      theme: "light",
      language: "en",
    });
    window.Featurebase("init_changelog_widget", {
      organization: "gymflow",
      dropdown: {
        enabled: true,
        placement: "right",
      },
      popup: {
        enabled: true,
        usersName: staff?.firstName,
        userId: loggedInId,
        autoOpenForNewUpdates: true,
      },
      theme: "light",
      locale: "en",
    });
    window.Featurebase("initialize_survey_widget", {
      organization: "gymflow",
      placement: "bottom-left",
      theme: "light",
      email: staff.email,
      locale: "en",
    });
  }, [club, loggedInId, staff, webSettings]);
}
